import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

const i4pLightTheme = {
  dark: false,
  headerLogo: '/img/dark-logo.png',
  colors: {
    // BASIC
    primary: '#FDB714',
    secondary: '#FFF4DC',
    textColor: '#000000',
    primaryButtonTextColor: '#FFFFFF',
    normalButtonBackground: '#f5f5f5',
    normalButtonTextColor: '#4A4A4A',
    background: '#F3F3F3',
    decline: '#FF7C7C',
    grey: '#9e9e9e',
    accent: '#82b1ff',
    modalButtonColor: '#68A9C5',
    success: {
      base: '#64c636',
      lighten1: '#E7FFD9',
      darken1: '#36C658'
    },
    error: '#FF7C7C',
    // HEADER
    headerBackground: '#272727',
    headerTextColor: '#FFFFFF',
    // CARD
    cardBackground: '#FFFFFF',
    cardText: '#9e9e9e',
    // DATATABLE
    datatableBackground: '#FFFFFF',
    datatableTextColor: '#4A4A4A',
    datatableHighlightBackground: '#eeeeee',
    // STATUS
    statusEnabled: '#e7ffd9',
    statusEnabledTextColor: '#64c636',
    statusInactive: '#d1e8ff',
    statusInactiveTextColor: '#007afe',
    // NAVBAR
    navbarIconColor: 'FDB714',
    navbarBackground: '#FFFFFF',
    navbarTextColor: '#000000',
    navbarActiveTextColor: '#FDB714',
    navbarIconBackground: '#FFF4DC',
    navbarActiveIcon: '#FFFFFF',
    navbarActiveIconBackground: '#FDB714',
    // FILTER BUTTON
    filterbutton: '#FFFFFF',
    filterbuttonTextColor: '#000000',
    // OTHER
    dragAndDropCardColor: '#f3f3f3',
    scrollbarThumbBackgroundColor: '#d6dee1',
    scrollbarThumbHoverBackgroundColor: '#a8bbbf'
  }
}

const Quanta = {
  name: 'Quanta',
  dark: false,
  headerLogo: '/img/quanta-dark-logo.png',
  colors: {
    // BASIC
    primary: '#fdb714',
    secondary: '#FFF4DC',
    textColor: '#000000',
    primaryButtonTextColor: '#FFFFFF',
    normalButtonBackground: '#f5f5f5',
    normalButtonTextColor: '#4A4A4A',
    background: '#F3F3F3',
    decline: '#BB5561',
    grey: '#9e9e9e',
    accent: '#82b1ff',
    modalButtonColor: '#81B1BC',
    success: {
      base: '#6CAA55',
      lighten1: '#E7FFD9',
      darken1: '#36C658'
    },
    error: '#BB5561',
    // HEADER
    headerBackground: '#18212D',
    headerTextColor: '#FFFFFF',
    // CARD
    cardBackground: '#FFFFFF',
    cardText: '#9e9e9e',
    // DATATABLE
    datatableBackground: '#FFFFFF',
    datatableTextColor: '#4A4A4A',
    datatableHighlightBackground: '#eeeeee',
    // STATUS
    statusEnabled: '#e7ffd9',
    statusEnabledTextColor: '#64c636',
    statusInactive: '#d1e8ff',
    statusInactiveTextColor: '#007afe',
    // NAVBAR
    navbarIconColor: '#629991',
    navbarBackground: '#FFFFFF',
    navbarTextColor: '#000000',
    navbarActiveTextColor: '#629998',
    navbarIconBackground: '#c5dce0',
    navbarActiveIcon: '#FFFFFF',
    navbarActiveIconBackground: '#629998',
    // FILTER BUTTON
    filterbutton: '#FFFFFF',
    filterbuttonTextColor: '#000000',
    // OTHER
    dragAndDropCardColor: '#f3f3f3',
    scrollbarThumbBackgroundColor: '#d6dee1',
    scrollbarThumbHoverBackgroundColor: '#a8bbbf'
  }
}

const MyCompany = {
  name: 'My Company',
  dark: false,
  headerLogo: '/img/myCompany.svg',
  colors: {
    // BASIC
    primary: '#FDD835 ',
    secondary: '#FFF4DC',
    textColor: '#000000',
    primaryButtonTextColor: '#35361d',
    normalButtonBackground: '#f5f5f5',
    normalButtonTextColor: '#4A4A4A',
    background: '#F3F3F3',
    decline: '#FF7C7C',
    grey: '#9e9e9e',
    accent: '#82b1ff',
    modalButtonColor: '#68A9C5',
    success: {
      base: '#64c636',
      lighten1: '#E7FFD9',
      darken1: '#36C658'
    },
    error: '#FF7C7C',
    // HEADER
    headerBackground: '#115d91',
    headerTextColor: '#FFFFFF',
    // CARD
    cardBackground: '#FFFFFF',
    cardText: '#9e9e9e',
    // DATATABLE
    datatableBackground: '#FFFFFF',
    datatableTextColor: '#4A4A4A',
    datatableHighlightBackground: '#eeeeee',
    // STATUS
    statusEnabled: '#e7ffd9',
    statusEnabledTextColor: '#64c636',
    statusInactive: '#d1e8ff',
    statusInactiveTextColor: '#007afe',
    // NAVBAR
    navbarIconColor: '0B9FFF',
    navbarBackground: '#FFFFFF',
    navbarTextColor: '#000000',
    navbarActiveTextColor: '#0B9FFF',
    navbarIconBackground: '#dcf8ff',
    navbarActiveIcon: '#FFFFFF',
    navbarActiveIconBackground: '#0B9FFF',
    // FILTER BUTTON
    filterbutton: '#FFFFFF',
    filterbuttonTextColor: '#000000',
    // OTHER
    dragAndDropCardColor: '#f3f3f3',
    scrollbarThumbBackgroundColor: '#d6dee1',
    scrollbarThumbHoverBackgroundColor: '#a8bbbf'
  }
}

export default new Vuetify({
  theme: {
    defaultTheme: 'i4pLightTheme',
    themes: {
      light: i4pLightTheme.colors, i4pLightTheme, Quanta, MyCompany
    },
    options: {
      customProperties: true
    }

  }
})
